export const STORE_NAME = 'interviewer-storage';
